import ActionDetail from "../components/PatientDetail/Action/ActionDetail";

export default function Action(props) {
  return (
    <div >
      <ActionDetail {...props} />
    </div>
  );
}
